
export default {
  data() {
    return {
      facebookShare: '',
      twitterShare: '',
      linkedInShare: '',
    };
  },
  mounted() {
    this.facebookShare = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href;
    this.twitterShare = 'https://twitter.com/intent/tweet?url=' + window.location.href;
    this.linkedInShare = 'https://www.linkedin.com/shareArticle?mini=true&url=' + window.location.href;
  },
};
